import { render, staticRenderFns } from "./myNotification.vue?vue&type=template&id=36cdc11e&"
import script from "./myNotification.vue?vue&type=script&lang=js&"
export * from "./myNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports